import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngxs/store';
import { InvoicePartner } from '../../../../../../_shared/model';
import { Recipient } from '../../../../../../_shared/model/accounting/recipient.model';
import { BaseState } from '../../../../../../_shared/state/base/base.state';
import { AccountingService, CommonService } from '../../../../../pages/home/_services';

@Component({
    selector: 'acc-wid-cmn-rcp-form',
    templateUrl: './acc-wid-cmn-rcp-form.component.html',
    styles: [],
})
export class AccWidCmnRcpFormComponent implements OnInit {
    @Input()
    public isEdit: boolean;

    @Input()
    public recipient: Recipient;

    @Input()
    public formSubmitted = false;

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @typescript-eslint/no-explicit-any
    public onChange: EventEmitter<any> = new EventEmitter<any>();

    public inputForm: FormGroup;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public zipCodes: any = [];

    private isDisableForm = false;
    private contractorId: number = this.store.selectSnapshot(BaseState.activeContractorId);
    constructor(
        private fb: FormBuilder,
        private commonRest: CommonService,
        private accrest: AccountingService,
        private store: Store,
    ) {}

    ngOnInit() {
        this.initZipCodes();
        this.createForm();
    }

    private initZipCodes(): void {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.commonRest.getZipCodes().subscribe((res: any[]) => {
            this.zipCodes = res;
        });
    }
    public createForm(): void {
        this.inputForm = this.fb.group({
            name: new FormControl({ value: '', disabled: this.isDisableForm }, Validators.required),
            addressName: new FormControl({
                value: '',
                disabled: this.isDisableForm,
            }),
            addressNumber: new FormControl({
                value: '',
                disabled: this.isDisableForm,
            }),
            postName: new FormControl({ value: '', disabled: this.isDisableForm }, Validators.required),
            postNumber: new FormControl({ value: '', disabled: this.isDisableForm }, Validators.required),
            postBox: new FormControl({ value: '', disabled: this.isDisableForm }, Validators.pattern('^[0-9]*$')),
            taxId: new FormControl({ value: '', disabled: this.isDisableForm }, Validators.minLength(8)),
            contractorId: this.contractorId,
            id: undefined,
        });
        if (this.recipient != undefined) {
            this.inputForm.patchValue(this.recipient);
            this.onChange.emit(this.inputForm);
        }
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
        this.inputForm.valueChanges.subscribe((data: any) => {
            this.onChange.emit(this.inputForm);
        });
    }

    public fillCity(e: { zipCode: string; city: string }) {
        if (e.city) {
            this.inputForm.controls.postName.setValue(e.city);
        }
    }
    public fillPost(e: { zipCode: string; city: string }) {
        if (e.zipCode) {
            this.inputForm.controls.postNumber.setValue(e.zipCode);
        }
    }
    public saveCustomerPayer(): void {
        this.formSubmitted = true;
        if (!this.inputForm.valid) {
            return;
        }

        const result: InvoicePartner = new InvoicePartner().deserialize(this.inputForm.value);
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.accrest.createUpdateInvoicePartner(this.contractorId, result).subscribe(res => {
            return result;
        });
        //dodamo v DB
    }
}
